"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logoutFromAEM = void 0;
const axios_1 = __importDefault(require("axios"));
const logoutFromAEM = logoutAEMUri => __awaiter(void 0, void 0, void 0, function* () {
  try {
    yield axios_1.default.get(logoutAEMUri, {
      withCredentials: true,
      timeout: 5000
    });
  } catch (e) {
    // logout error from AEM should not break the logout process
    console.log(e);
  }
  return Promise.resolve();
});
exports.logoutFromAEM = logoutFromAEM;
//# sourceMappingURL=index.js.map